import { localizedTimezoneNames } from "./timezoneNames.js";
const cityNames = {
    Amsterdam: { en: "Amsterdam", "zh-Hant": "阿姆斯特丹", "zh-Hans": "阿姆斯特丹" },
    Athens: { en: "Athens", "zh-Hant": "雅典", "zh-Hans": "雅典" },
    Auckland: { en: "Auckland", "zh-Hant": "奧克蘭", "zh-Hans": "奥克兰" },
    Bangkok: { en: "Bangkok", "zh-Hant": "曼谷", "zh-Hans": "曼谷" },
    Berlin: { en: "Berlin", "zh-Hant": "柏林", "zh-Hans": "柏林" },
    Buenos_Aires: { en: "Buenos Aires", "zh-Hant": "布宜諾斯艾利斯", "zh-Hans": "布宜诺斯艾利斯" },
    Cairo: { en: "Cairo", "zh-Hant": "開羅", "zh-Hans": "开罗" },
    Chicago: { en: "Chicago", "zh-Hant": "芝加哥", "zh-Hans": "芝加哥" },
    Denver: { en: "Denver", "zh-Hant": "丹佛", "zh-Hans": "丹佛" },
    Dubai: { en: "Dubai", "zh-Hant": "杜拜", "zh-Hans": "迪拜" },
    Hong_Kong: { en: "Hong Kong", "zh-Hant": "香港", "zh-Hans": "香港" },
    Ho_Chi_Minh: { en: "Ho Chi Minh", "zh-Hant": "胡志明", "zh-Hans": "胡志明" },
    Istanbul: { en: "Istanbul", "zh-Hant": "伊斯坦堡", "zh-Hans": "伊斯坦布尔" },
    Jakarta: { en: "Jakarta", "zh-Hant": "雅加達", "zh-Hans": "雅加达" },
    Johannesburg: { en: "Johannesburg", "zh-Hant": "約翰尼斯堡", "zh-Hans": "约翰内斯堡" },
    Kuala_Lumpur: { en: "Kuala Lumpur", "zh-Hant": "吉隆坡", "zh-Hans": "吉隆坡" },
    London: { en: "London", "zh-Hant": "倫敦", "zh-Hans": "伦敦" },
    Los_Angeles: { en: "Los Angeles", "zh-Hant": "洛杉磯", "zh-Hans": "洛杉矶" },
    Manila: { en: "Manila", "zh-Hant": "馬尼拉", "zh-Hans": "马尼拉" },
    Melbourne: { en: "Melbourne", "zh-Hant": "墨爾本", "zh-Hans": "墨尔本" },
    Mexico_City: { en: "Mexico City", "zh-Hant": "墨西哥城", "zh-Hans": "墨西哥城" },
    Moscow: { en: "Moscow", "zh-Hant": "莫斯科", "zh-Hans": "莫斯科" },
    Mumbai: { en: "Mumbai", "zh-Hant": "孟買", "zh-Hans": "孟买" },
    New_York: { en: "New York", "zh-Hant": "紐約", "zh-Hans": "纽约" },
    Paris: { en: "Paris", "zh-Hant": "巴黎", "zh-Hans": "巴黎" },
    Rome: { en: "Rome", "zh-Hant": "羅馬", "zh-Hans": "罗马" },
    Sao_Paulo: { en: "Sao Paulo", "zh-Hant": "聖保羅", "zh-Hans": "圣保罗" },
    Seoul: { en: "Seoul", "zh-Hant": "首爾", "zh-Hans": "首尔" },
    Shanghai: { en: "Shanghai", "zh-Hant": "上海", "zh-Hans": "上海" },
    Singapore: { en: "Singapore", "zh-Hant": "新加坡", "zh-Hans": "新加坡" },
    Stockholm: { en: "Stockholm", "zh-Hant": "斯德哥爾摩", "zh-Hans": "斯德哥尔摩" },
    Sydney: { en: "Sydney", "zh-Hant": "雪梨", "zh-Hans": "悉尼" },
    Taipei: { en: "Taipei", "zh-Hant": "台北", "zh-Hans": "台北" },
    Tokyo: { en: "Tokyo", "zh-Hant": "東京", "zh-Hans": "东京" },
    Toronto: { en: "Toronto", "zh-Hant": "多倫多", "zh-Hans": "多伦多" },
    Vancouver: { en: "Vancouver", "zh-Hant": "溫哥華", "zh-Hans": "温哥华" }
};
export function createTimezoneOptions(input) {
    const date = input.date ?? new Date();
    const discoveredTimezones = input.timezones ?? discoverTimezones();
    const timezones = [...new Set([...discoveredTimezones, ...(input.additionalTimezones ?? [])].filter(Boolean))];
    return timezones
        .map((timezone) => {
        const { label: offsetLabel, minutes: offsetMinutes } = getTimezoneOffset(timezone, date);
        const cityLabel = formatTimezoneName(timezone, input.locale);
        return {
            label: `(${offsetLabel}) ${cityLabel}`,
            value: timezone,
            cityLabel,
            offsetMinutes
        };
    })
        .sort((left, right) => left.offsetMinutes - right.offsetMinutes || left.label.localeCompare(right.label));
}
export function formatTimezoneName(timezone, locale) {
    const cityKey = timezone.split("/").pop() || timezone;
    const knownCityName = cityNames[cityKey]?.[locale];
    if (knownCityName)
        return knownCityName;
    if (locale !== "en") {
        const localizedLocation = localizedTimezoneNames[timezone]?.[locale];
        if (localizedLocation)
            return localizedLocation;
    }
    return cityKey.replace(/_/g, " ");
}
export function getTimezoneOffset(timezone, date = new Date()) {
    try {
        const part = new Intl.DateTimeFormat("en-US", {
            timeZone: timezone,
            timeZoneName: "longOffset"
        }).formatToParts(date).find(({ type }) => type === "timeZoneName");
        const rawOffset = part?.value ?? "GMT";
        const match = /^GMT([+-])(\d{1,2})(?::(\d{2}))?$/.exec(rawOffset);
        if (match) {
            const hours = Number(match[2]);
            const minutes = Number(match[3] ?? "0");
            const totalMinutes = hours * 60 + minutes;
            const signedMinutes = match[1] === "-" ? -totalMinutes : totalMinutes;
            const sign = signedMinutes < 0 ? "-" : "+";
            const absoluteMinutes = Math.abs(signedMinutes);
            return {
                label: `UTC${sign}${String(Math.floor(absoluteMinutes / 60)).padStart(2, "0")}:${String(absoluteMinutes % 60).padStart(2, "0")}`,
                minutes: signedMinutes
            };
        }
    }
    catch {
        // Keep invalid or unsupported values selectable with a stable zero offset.
    }
    return { label: "UTC+00:00", minutes: 0 };
}
function discoverTimezones() {
    const supportedValuesOf = Intl.supportedValuesOf;
    const supportedTimezones = supportedValuesOf?.("timeZone") ?? ["UTC"];
    const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return [...supportedTimezones, localTimezone || "UTC"];
}
